module.exports = __webpack_public_path__ + "710f2040adadb4b30cecc7b293acc016.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header.png
// module id = 175
// module chunks = 0